<div class="page">
  <div class="header">
    <button mat-icon-button (click)="cerrar()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>
        {{
          data?.modo === 'nuevo'
            ? 'Nuevo paciente'
            : data?.modo === 'editar'
              ? 'Editar información del paciente'
              : 'Información del paciente'
        }}
      </h1>
      <p>
        {{
          data?.modo === 'nuevo'
            ? 'Completa la información para agregar un nuevo paciente'
            : data?.modo === 'editar'
              ? 'Actualiza los datos personales y de contacto del paciente'
              : 'Datos generales y clínicos del paciente'
        }}
      </p>
    </div>
  </div>

  <div class="card">
    <button mat-button type="button" (click)="rellenarFormulario()">Rellenar prueba</button>

    <mat-stepper
      linear
      labelPosition="bottom"
      #stepper
      (selectionChange)="onStepChange($event.selectedIndex)"
    >
      <!-- DATOS PERSONALES -->
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="firstFormGroup" class="historia-form">
          <ng-template matStepLabel>Datos personales</ng-template>

          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre(s)</mat-label>
              <input matInput placeholder="Nombre(s)" formControlName="nombre" />

              <mat-error>
                @if (firstFormGroup.get('nombre')?.hasError('required')) {
                  El nombre es obligatorio.
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Apellido paterno</mat-label>
              <input
                matInput
                placeholder="Apellido paterno"
                formControlName="apellidoPaterno"
                required
              />

              <mat-error>
                @if (firstFormGroup.get('apellidoPaterno')?.hasError('required')) {
                  El apellido paterno es obligatorio.
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Apellido materno</mat-label>
              <input matInput placeholder="Apellido materno" formControlName="apellidoMaterno" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Fecha de nacimiento</mat-label>

              <input
                matInput
                [matDatepicker]="picker"
                [max]="fechaMaxima"
                formControlName="fechaNacimiento"
                placeholder="dd/mm/aaaa"
                required
              />

              <mat-hint>{{ obtenerEdad() }}</mat-hint>

              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

              <mat-datepicker #picker startView="multi-year"></mat-datepicker>

              <mat-error>
                @if (firstFormGroup.get('fechaNacimiento')?.hasError('required')) {
                  La fecha de nacimiento es obligatoria.
                }

                @if (firstFormGroup.get('fechaNacimiento')?.hasError('matDatepickerMax')) {
                  La fecha no puede ser en el futuro.
                }

                @if (firstFormGroup.get('fechaNacimiento')?.hasError('matDatepickerParse')) {
                  Ingresa una fecha válida en formato dd/mm/aaaa.
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Género</mat-label>
              <mat-select formControlName="genero">
                <mat-option value="femenino">Femenino</mat-option>
                <mat-option value="masculino">Masculino</mat-option>
              </mat-select>

              <mat-error>
                @if (firstFormGroup.get('genero')?.hasError('required')) {
                  El genero es obligatorio.
                }
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tipo de sangre</mat-label>
              <input matInput placeholder="A+" formControlName="tipoSangre" required />
            </mat-form-field>
          </div>
        </form>
      </mat-step>

      <!-- CONTACTO -->
      <mat-step [stepControl]="pasoContactoGuardado">
        <form [formGroup]="secondFormGroup" class="historia-form">
          <ng-template matStepLabel>Contacto</ng-template>

          <div class="historia-scroll">
            <h3 class="titulo-historia">Contacto del paciente</h3>
            <div class="form-grid">
              <!-- MUNICIPIO -->
              <mat-form-field appearance="outline">
                <mat-label>Municipio</mat-label>
                <input
                  matInput
                  formControlName="municipio"
                  [matAutocomplete]="autoMunicipio"
                  placeholder="Huajuapan de León"
                  required
                />

                <mat-autocomplete #autoMunicipio="matAutocomplete" [displayWith]="mostrarCatalogo">
                  @for (m of municipiosFiltrados; track m.id) {
                    <mat-option [value]="m">{{ m.nombre }}</mat-option>
                  }
                </mat-autocomplete>

                <mat-hint>{{ ayudaMunicipio }}</mat-hint>

                <mat-error>
                  @if (secondFormGroup.get('municipio')?.hasError('required')) {
                    El municipio es obligatorio.
                  }
                </mat-error>
              </mat-form-field>

              <!-- BARRIO O COLONIA -->
              <mat-form-field appearance="outline">
                <mat-label>Colonia o barrio</mat-label>
                <input
                  matInput
                  formControlName="barrio"
                  [matAutocomplete]="autoBarrio"
                  placeholder="Colonia o barrio"
                  required
                />

                <mat-autocomplete #autoBarrio="matAutocomplete" [displayWith]="mostrarCatalogo">
                  @for (b of barriosFiltrados; track b.id) {
                    <mat-option [value]="b">{{ b.nombre }}</mat-option>
                  }
                </mat-autocomplete>

                <mat-hint>{{ ayudaBarrio }}</mat-hint>

                <mat-error>
                  @if (secondFormGroup.get('barrio')?.hasError('required')) {
                    La colonia o barrio es obligatoria.
                  }
                </mat-error>
              </mat-form-field>

              <!-- DIRECCIÓN -->
              <mat-form-field appearance="outline">
                <mat-label>Dirección</mat-label>
                <input
                  matInput
                  placeholder="Calle, Número, C.P, Estado"
                  formControlName="direccion"
                  required
                />

                <mat-error>
                  @if (secondFormGroup.get('direccion')?.hasError('required')) {
                    La dirección es obligatoria.
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Número telefónico</mat-label>
                <input
                  matInput
                  type="text"
                  inputmode="numeric"
                  maxlength="10"
                  placeholder="XXX XXX XXXX"
                  formControlName="telefono"
                  (input)="soloNumeros($event, 'telefono')"
                />

                <mat-error>
                  @if (secondFormGroup.get('telefono')?.hasError('required')) {
                    El número telefónico es obligatorio.
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="email"
                  placeholder="correo@ejemplo.com"
                  formControlName="email"
                />

                @if (secondFormGroup.get('email')?.hasError('email')) {
                  <mat-error> Ingresa un correo electrónico válido. </mat-error>
                }
              </mat-form-field>
            </div>

            <h3 class="titulo-historia">Contacto de emergencia</h3>
            <div class="form-grid">
              <mat-form-field appearance="outline">
                <mat-label>Nombre de contacto de emergencia</mat-label>
                <input
                  matInput
                  placeholder="Nombre completo"
                  formControlName="contactoEmergencia"
                  required
                />

                <mat-error>
                  @if (secondFormGroup.get('contactoEmergencia')?.hasError('required')) {
                    El nombre del contacto de emergencia es obligatorio.
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Parentesco</mat-label>
                <input
                  matInput
                  placeholder="Padre, madre, esposo, esposa, etc"
                  formControlName="parentesco"
                  required
                />
                <mat-error>
                  @if (secondFormGroup.get('parentesco')?.hasError('required')) {
                    El parentesco es obligatorio.
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Dirección</mat-label>
                <input
                  matInput
                  placeholder="Calle, Número, Colonia (barrio), C.P, Ciudad, Estado"
                  formControlName="direccionEmergencia"
                  required
                />
                <mat-error>
                  @if (secondFormGroup.get('direccionEmergencia')?.hasError('required')) {
                    La dirección del contacto de emergencia es obligatorio.
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Número telefonico</mat-label>
                <input
                  matInput
                  type="text"
                  inputmode="numeric"
                  maxlength="10"
                  placeholder="XXX XXX XXXX"
                  formControlName="telefonoEmergencia"
                  (input)="soloNumeros($event, 'telefonoEmergencia')"
                />
                <mat-error>
                  @if (secondFormGroup.get('telefonoEmergencia')?.hasError('required')) {
                    El número de telefónico del contacto de emergencia es obligatorio.
                  }
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  type="email"
                  placeholder="correo@ejemplo.com"
                  formControlName="emailEmergencia"
                />
                <mat-error>
                  @if (secondFormGroup.get('emailEmergencia')?.hasError('email')) {
                    Ingresa un correo electrónico válido.
                  }
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Consentimientos</ng-template>
        <div class="consentimientos-grid">
          <!-- ! CONSENTIMIENTO INFORMADO PARA PROCEDIMIENTOS MENORES -->
          <section class="consentimiento-card">
            <mat-icon class="consentimiento-icon">healing</mat-icon>

            <div class="consentimiento-info">
              <h2>Procedimientos menores</h2>
              <p>
                Consentimiento para documentar la autorización de un procedimiento médico menor.
              </p>
            </div>

            <button
              mat-flat-button
              type="button"
              class="add-boton"
              [disabled]="!tieneExpedienteMedico"
              (click)="generarConsentimientoProcedimientosMenores()"
            >
              <mat-icon>picture_as_pdf</mat-icon>
              Generar PDF
            </button>
          </section>

          <!-- ! CONSENTIMIENTO INFORMADO PARA INTERNAMIENTO -->

          <section class="consentimiento-card">
            <mat-icon class="consentimiento-icon">local_hospital</mat-icon>

            <div class="consentimiento-info">
              <h2>Consentimiento internamiento</h2>
              <p>Consentimiento para documentar la autorización de internamiento</p>
            </div>

            <button
              mat-flat-button
              type="button"
              class="add-boton"
              [disabled]="!tieneExpedienteMedico"
              (click)="generarConsentimientoInternamiento()"
            >
              <mat-icon>picture_as_pdf</mat-icon>
              Generar PDF
            </button>
          </section>

          <!-- ! CONSENTIMIENTO INFORMADO PARA INTERNAMIENTO 2 -->

          <section class="consentimiento-card">
            <mat-icon class="consentimiento-icon">assignment_turned_in</mat-icon>

            <div class="consentimiento-info">
              <h2>Consentimiento internamiento</h2>
              <p>Consentimiento para documentar la autorización de internamiento.</p>
            </div>

            <button
              mat-flat-button
              type="button"
              class="add-boton"
              [disabled]="!tieneExpedienteMedico"
              (click)="generarConsentimientoInternamiento2()"
            >
              <mat-icon>picture_as_pdf</mat-icon>
              Generar PDF
            </button>
          </section>

          <!-- ! DENEGACIÓN DE CONSENTIMIENTO INFORMADO PARA INTERNAMIENTO -->

          <section class="consentimiento-card">
            <mat-icon class="consentimiento-icon">block</mat-icon>

            <div class="consentimiento-info">
              <h2>Denegación de consentimiento internamiento</h2>
              <p>Consentimiento para documentar la denegación de internamiento.</p>
            </div>

            <button
              mat-flat-button
              type="button"
              class="add-boton"
              [disabled]="!tieneExpedienteMedico"
              (click)="generarConsentimientoInternamientoDenegacion()"
            >
              <mat-icon>picture_as_pdf</mat-icon>
              Generar PDF
            </button>
          </section>

          <!-- ! CONSENTIMIENTO INFORMADO PARA TRATAMIENTO AMBULATORIO -->

          <section class="consentimiento-card">
            <mat-icon class="consentimiento-icon">medical_services</mat-icon>

            <div class="consentimiento-info">
              <h2>Consentimiento ambulatorio</h2>
              <p>
                Autorización informada para recibir atención y tratamiento de forma ambulatoria.
              </p>
            </div>

            <button
              mat-flat-button
              type="button"
              class="add-boton"
              [disabled]="!tieneExpedienteMedico"
              (click)="generarConsentimientoAmbulatorio()"
            >
              <mat-icon>picture_as_pdf</mat-icon>
              Generar PDF
            </button>
          </section>
        </div>

        <!-- <div class="sin-datos">
          <mat-icon>lock</mat-icon>
          <h2>No hay consentimientos disponibles</h2>
          <p>Guarda el paciente para habilitar los consentimientos.</p>
        </div> -->
      </mat-step>
    </mat-stepper>

    <div class="stepper-footer">
      @if (!esUltimoPaso && pasoActual > 0) {
        <button class="add-boton" mat-button type="button" (click)="anterior(stepper)">
          <mat-icon>arrow_back</mat-icon> Anterior
        </button>
      } @else {
        <span></span>
      }

      @if (esUltimoPaso) {
        <button
          class="add-boton"
          mat-flat-button
          type="button"
          [disabled]="!pacienteGuardado?.id && !data?.paciente?.id"
          (click)="abrirRegistroSignosVitales(pacienteGuardado)"
        >
          Abrir signos vitales
          <mat-icon>monitor_heart</mat-icon>
        </button>
      } @else if (pasoActual === 1 && !soloLectura && !pacienteGuardado) {
        <button
          class="add-boton"
          mat-flat-button
          type="button"
          [disabled]="guardandoPaciente"
          (click)="guardarPaciente(stepper)"
        >
          Guardar paciente
          <mat-icon>save</mat-icon>
        </button>
      } @else {
        <button class="add-boton" mat-button type="button" (click)="siguiente(stepper)">
          Siguiente
          <mat-icon iconPositionEnd>arrow_forward</mat-icon>
        </button>
      }
    </div>
  </div>
</div>
